/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  ADD_ACCOUNT_FILTER,
  ADD_ACCOUNT_FILTER_SUCCESS,
  ADD_ACCOUNT_FILTER_FAILURE
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse
} from "./reducerUtils";

const initialState = {
  data: null,
  state: "INIT",
  error: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_ACCOUNT_FILTER:
      return setLoadingState(state);

    case ADD_ACCOUNT_FILTER_SUCCESS:
      return setSuccessResponse(state, action);

    case ADD_ACCOUNT_FILTER_FAILURE:
      return setErrorResponse(state, action);
    default:
      return state;
  }
}
